/**
 * Created by Kristy on 30/6/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('adminSchedulesGrid', {
                parent: 'app',
                url: '/schedules/grid',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_HEALTH_VISITOR', 'ROLE_PHARM_VISITOR', 'ROLE_PHARM_SUPERVISOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminSchedulesGrid/adminSchedulesGrid.html',
                        controller: 'AdminSchedulesGridController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
